<template>
  <el-aside class="my-aside">
    <div class="top">
      <div class="title">所有类别</div>
      <div class="search">
        <el-input size="small" placeholder="搜索类别" v-model="keyword" @clear="onFilter" clearable>
          <el-button slot="append" icon="el-icon-search" @click="onFilter"></el-button>
        </el-input>
      </div>
    </div>
    <div class="tree m-scroll">
      <el-tree ref="tree" :data="types" node-key="RecordId" :filter-node-method="onFilterFunc" default-expand-all :props="defaultProps"
        check-on-click-node :expand-on-click-node="false" @node-click="onSelect">
        <span class="custom-tree-node" slot-scope="{ node }">
          <span :class="{ 'current-node': node.isCurrent }">{{ node.label }}</span>
        </span>
      </el-tree>
    </div>
  </el-aside>
</template>
<script>
export default {
  components: {},
  props: {
    IsEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      keyword: "",
      types: [],
      defaultProps: {
        children: "children",
        label: "TypeName",
      },
      api: require("@/api/goods/typeplatform").default,
    };
  },
  methods: {
    getData() {
      console.log("getData")
      this.api.list({ State: 1 }).then((res) => {
        var root = {
          RecordId: -1, OrderId: 0, TypeName: "宝物分类", TypeLevel: 0,
          TypeIdParent: null, TypeNameParent: "", State: 1
        };
        this.types = this.$commonJs.toTreeData(res.Data, "RecordId", "TypeIdParent", "children", root);
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(-1);
        });
      });
    },
    onFilter() {
      this.$refs.tree.filter(this.keyword);
    },
    onFilterFunc(value, data) {
      if (!value) return true;
      return data.TypeName.indexOf(value) !== -1;
    },
    onSelect(data) {
      this.$emit("on-select2", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.my-aside {
  width: 260px !important;
  padding: 0;
  margin: 0;
  background-color: white;

  .top {
    border: 1px solid #dedede;
    .title {
      height: 40px;
      line-height: 40px;
      text-align: center;
      border-bottom: 1px solid #dedede;
      margin-bottom: 5px;
      color: #909399;
    }

    .search {
      padding: 0 8px;
      margin-bottom: 5px;
    }
  }

  .tree {
    overflow-y: auto;
    height: 695px;
    border: 1px solid #dedede;
    border-top: none;
  }
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  line-height: 40px;
  padding-right: 8px;
}

.el-button {
  font-size: 18px;
}

.current-node {
  color: #409eff;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #eee;
    }
  }
}
</style>